<template>
  <div class="d-flex align-center justify-space-between" style="height: 50px">
    <div class="d-flex align-center">
      <div class="d-flex justify-space-between" style="width: 220px">
        <div style="width: 130px">{{ kind === 'cen' ? 'Học phí:' : 'Thu hộ / chi hộ:' }}</div>
        <div class="text-right">
          {{ item[kind].totalAmount | price }}
        </div>
        <div class="ml-4" v-if="isTeacher">
          <v-icon color="#46BE8A" v-if="item[kind].isPaid">mdi-checkbox-marked-circle</v-icon>
          <v-icon color="#F4BB43" v-else>mdi-cancel</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
export default {
  components: {},
  props: {
    kind: String,
    item: Object,
    viewIsPaid: Boolean
  },
  computed: {
    ...mapState('auth', ['role']),
    isTeacher() {
      return get(this.role, 'type') === 'teacher'
    }
  },
  methods: {
    countMoney(totalSum = 0, totalMinus = 0) {
      return totalSum - totalMinus
    },
    getTextPaid(item) {
      if (this.kind !== 'cen') return ''
      if (item.status === 'over') return 'Thừa'
      if (item.status === 'under') return 'Thiếu'
      return ''
    },
    getColorPaid(item) {
      if (this.kind !== 'cen') return ''
      if (item.status === 'over') return 'color: green'
      if (item.status === 'under') return 'color: red'
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
  min-width: 70px;
}
</style>
